import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "OLT DEPLOYMENT", "GPON", "XGS-PON", "FTTH", "FIBER SPLICING",
  "E-BAND RADIO", "5G ROLLOUT", "TOWER CIVIL WORKS", "OTDR TESTING",
  "STRUCTURED CABLING", "O&M", "MATERIAL SUPPLY",
];

export default function MarqueeStrip() {
  return (
    <div
      className="relative py-8 border-y border-white/10 bg-[#0C1322] overflow-hidden"
      data-testid="marquee-strip"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-extrabold text-4xl md:text-6xl tracking-tight text-transparent mx-8"
              style={{ WebkitTextStroke: "1px rgba(0,240,255,0.55)" }}>
              {w}
            </span>
            <span className="text-cyan text-2xl" style={{ color: "#00F0FF" }}>/</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
